const actions = {

  // ////////////////////////////////////////////
  // SIDEBAR & UI UX
  // ////////////////////////////////////////////

  // updateI18nLocale({ commit }, locale) {
  //   commit('UPDATE_I18N_LOCALE', locale)
  // },
  // updateTheme({ commit }, val) {
  //   commit('UPDATE_THEME', val)
  // }
  // updateUserRole({ commit }, val) {
  //   commit('UPDATE_USER_ROLE', val)
  // },
}

export default actions
